import cdnLoader from '../../cdn-loader';

/** Matches OptimizedBannerView `min-[600px]` split. */
export const LCP_MOBILE_MEDIA = '(max-width: 599px)';
export const LCP_DESKTOP_MEDIA = '(min-width: 600px)';
export const LCP_MOBILE_WIDTH = 860;
export const LCP_DESKTOP_WIDTH = 1024;
export const CHANNEL_LANDING_DESKTOP_WIDTH = 1920;

export function cdnLcpUrl(src: string | undefined | null, width: number): string | undefined {
  if (!src || src === 'null' || src === 'undefined') return undefined;
  return cdnLoader({ src, width, quality: 85 });
}
